import { useRoot } from "./useRoot";

/**
 * Expose config plugin
 */
export function useConfig() {
  const root = useRoot();
  return root.$config;
}
